'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _slateReact = require('slate-react');

var _slate = require('slate');

var _SlateNode = require('./SlateNode');

var _SlateNode2 = _interopRequireDefault(_SlateNode);

var _slateFunctions = require('./slateFunctions');

var _lodash = require('lodash');

var _Button = require('@upgrowth/react-fulcrum/lib/elements/Button');

var _Button2 = _interopRequireDefault(_Button);

var _HoverMenu = require('./HoverMenu');

var _HoverMenu2 = _interopRequireDefault(_HoverMenu);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*
  Collaborative editing would be a lot of work to get going.
  Locking is probably a better proposition (TODO)
 */


var initialValue = _slate.Value.fromJSON({
  document: {
    nodes: [{
      object: 'block',
      type: 'p',
      nodes: [{
        object: 'text',
        leaves: [{
          text: 'A line of text in a paragraph.'
        }]
      }]
    }]
  }
});

var SlateEditor = function (_React$PureComponent) {
  (0, _inherits3.default)(SlateEditor, _React$PureComponent);

  function SlateEditor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SlateEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlateEditor.__proto__ || (0, _getPrototypeOf2.default)(SlateEditor)).call.apply(_ref, [this].concat(args))), _this), _this.initialValue = function () {
      console.log('getting initial value from props', _this.props);

      var value = _slate.Value.fromJSON((0, _lodash.isEmpty)(_this.props.value) ? initialValue : {
        document: _this.props.value
      });

      console.log('value', {
        document: _this.props.value
      });
      return value;
    }, _this.state = {
      value: _this.initialValue(),
      readOnly: true
    }, _this.handleChange = function (_ref2) {
      var value = _ref2.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          path = _this$props.path;
      console.log('Change', value.document, _this.state.value.document, value.document === _this.state.value.document);

      if (value.document !== _this.state.value.document) {
        var doc = value.toJSON().document;
        console.log('Uploading change', doc);
        onChange(path, doc);
      }

      _this.setState({
        value: value
      });
    }, _this.handlePaste = function (event, change, editor) {
      var pasted = (event.clipboardData || window.clipboardData).getData('text');
      console.log('handling paste', pasted, blocks);
      var result = find(toPairs(blocks), function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            id = _ref4[0],
            block = _ref4[1];

        console.log('matching block', block);
        return find(block.pasteTriggers || [], function (trigger) {
          console.log('matching', pasted, trigger);
          return pasted.match(trigger);
        });
      });
      var type = result && result[0];

      if (type) {
        var blockProperties = {
          type: type,
          data: {
            url: pasted
          },
          isVoid: true
        };
        console.log('Adding block', blockProperties);
        return change.insertBlock(blockProperties);
      }
    }, _this.handleAppendBlock = function (type) {
      var newBlock = (0, _slateFunctions.newBlockOfType)(type, _this.props.type.of.blocks);

      var change = _this.state.value.change().moveToEndOfNode(_this.state.value.document.nodes.last()).insertNodeByKey(_this.state.value.document.key, _this.state.value.document.nodes.count(), newBlock).moveToEndOfDocument().focus();

      _this.setState({
        value: change.value
      });
    }, _this.handleKeyDown = function (e, change) {
      if (_this.state.readOnly) {
        return;
      } // adapted from https://github.com/skogsmaskin/slate-insert-block-on-enter/blob/master/src/index.js


      var value = change.value;
      var _this$props$type$of = _this.props.type.of,
          defaultBlockType = _this$props$type$of.defaultBlockType,
          blocks = _this$props$type$of.blocks;
      defaultBlockType = defaultBlockType || (0, _lodash.keys)(blocks)[0];

      if (e.key === 'Enter') {
        var document = value.document,
            startKey = value.startKey,
            endKey = value.endKey,
            startBlock = value.startBlock;

        if (startBlock && startKey === endKey) {
          var nextBlock = document.getNextBlock(startKey);
          var prevBlock = document.getPreviousBlock(startKey);
          var isFocusedStart = value.selection.hasEdgeAtStartOf(startBlock);
          var isFocusedEnd = value.selection.hasEdgeAtEndOf(startBlock);
          var blockToInsert = (0, _slateFunctions.newBlockOfType)(defaultBlockType, blocks);

          if (!isFocusedEnd) {
            return;
          } // Void block at the end of the document


          if (!nextBlock) {
            return change.collapseToEndOf(startBlock).insertBlock(blockToInsert).collapseToEnd();
          } // Void block between two blocks


          if (nextBlock && prevBlock) {
            return change.collapseToEndOf(startBlock).insertBlock(blockToInsert);
          } // Void block in the beginning of the document


          if (nextBlock && !prevBlock) {
            return change.collapseToStartOf(startBlock).insertNodeByKey(document.key, 0, blockToInsert);
          }
        }
      }
    }, _this.updateMenu = function () {
      var value = _this.state.value;
      var menu = _this.menu;
      console.log('Updating menu', menu);
      if (!menu) return;

      if (value.isBlurred || value.isEmpty) {
        menu.removeAttribute('style');
        return;
      }

      var selection = window.getSelection();
      var range = selection.getRangeAt(0);
      var rect = range.getBoundingClientRect();
      menu.style.opacity = 1;
      menu.style.top = rect.top + window.pageYOffset - menu.offsetHeight + 'px';
      menu.style.left = rect.left + window.pageXOffset - menu.offsetWidth / 2 + rect.width / 2 + 'px';
    }, _this.renderMark = function (_ref5) {
      var attributes = _ref5.attributes,
          mark = _ref5.mark,
          children = _ref5.children;
      var marks = _this.props.type.of.marks;
      var As = mark.type;
      var markConfig = marks[As];
      console.log('Rendering mark', As, mark);

      if (!markConfig || markConfig.type) {
        return;
      }

      var data = mark.data ? mark.data.toJS() : {};
      return _react2.default.createElement(As, (0, _extends3.default)({}, data, attributes), children);
    }, _this.toggleReadOnly = function () {
      return _this.setState({
        readOnly: !_this.state.readOnly
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SlateEditor, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref6) {
      var value = _ref6.value;

      if (this.state.readOnly) {
        if (value !== this.props.value) {
          this.setState({
            value: _slate.Value.fromJS({
              document: this.props.value
            })
          });
        }
      } else {
        this.updateMenu();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          types = _props.types,
          _props$type$of = _props.type.of;
      _props$type$of = _props$type$of === undefined ? {} : _props$type$of;
      var blocks = _props$type$of.blocks,
          marks = _props$type$of.marks;
      var _state = this.state,
          value = _state.value,
          readOnly = _state.readOnly;
      var htmlBlockNames = (0, _lodash.chain)(blocks).pickBy(function (_ref7) {
        var type = _ref7.type;
        return !type;
      }).mapValues(function (_, id) {
        return id;
      }).value();
      console.log('Rendering value!', value.toJS(), value, blocks, this.props);
      return _react2.default.createElement('div', {
        className: 'SlateEditor ' + (readOnly ? 'readOnly' : '')
      }, _react2.default.createElement(_HoverMenu2.default, {
        innerRef: function innerRef(menu) {
          return _this2.menu = menu;
        },
        value: value,
        marks: marks,
        blocks: htmlBlockNames,
        onChange: this.handleChange
      }), _react2.default.createElement('div', {
        className: 'SlateEditor-header'
      }, _react2.default.createElement('div', {
        className: 'header-name'
      }, name), _react2.default.createElement('div', {
        className: 'header-description'
      }, readOnly ? ' Streaming Live' : ' Overwriting'), _react2.default.createElement('div', {
        className: 'header-actions'
      }, readOnly ? _react2.default.createElement(_Button2.default, {
        onClick: this.toggleReadOnly
      }, 'Pause and Edit') : _react2.default.createElement(_Button2.default, {
        onClick: this.toggleReadOnly
      }, 'Resume streaming'))), _react2.default.createElement(_slateReact.Editor, {
        value: value,
        readOnly: readOnly,
        onChange: this.handleChange,
        renderNode: function renderNode(props) {
          return _react2.default.createElement(_SlateNode2.default, (0, _extends3.default)({
            types: types,
            blocks: blocks
          }, props));
        },
        onPaste: this.handlePaste,
        onKeyDown: this.handleKeyDown,
        renderMark: this.renderMark
      }));
    }
  }]);
  return SlateEditor;
}(_react2.default.PureComponent);

exports.default = SlateEditor;